/* eslint-disable */
export default {
  dncAlert: 'Deze contactpersoon staat op een Niet bellen-lijst.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
